export default __webpack_public_path__ + "static/media/icon-calendar.2115316c.svg";